export default __webpack_public_path__ + "static/header-2f99ae83f816d930ee2da8150971a23985a6acf502794ca3353a8149010ce10a.png";